import { Channel } from './types';

export function getChannelNumber(channel: Channel) {
  return channel.virtualNumber ?? channel.channelNumber;
}
